import { For, createSignal, onCleanup, onMount } from 'solid-js';
import { useWindowManager } from '../lib/windowManager';
import { PixelIcon } from './PixelIcon';

interface TaskbarProps {
  startOpen: boolean;
  toggleStart: () => void;
}

function Clock() {
  const formatter = new Intl.DateTimeFormat(undefined, { hour: '2-digit', minute: '2-digit' });
  const [time, setTime] = createSignal(formatter.format(new Date()));
  let timer: number | undefined;

  onMount(() => {
    timer = window.setInterval(() => setTime(formatter.format(new Date())), 15_000);
  });
  onCleanup(() => timer && window.clearInterval(timer));

  return <time class="taskbar-clock">{time()}</time>;
}

export function Taskbar(props: TaskbarProps) {
  const manager = useWindowManager();

  return (
    <footer class="taskbar" aria-label="Taskbar">
      <button
        class="start-button"
        classList={{ pressed: props.startOpen }}
        onClick={(event) => {
          event.stopPropagation();
          props.toggleStart();
        }}
        aria-expanded={props.startOpen}
        aria-controls="start-menu"
      >
        <span class="start-mark">IS</span>
        <strong>Start</strong>
      </button>
      <div class="taskbar-divider" />
      <div class="taskbar-windows" role="list">
        <For each={manager.windows}>
          {(item) => {
            const active = () => manager.activeWindowId() === item.id && !item.minimized;
            return (
              <button
                class="taskbar-window-button"
                classList={{ active: active(), minimized: item.minimized }}
                onClick={() => {
                  if (item.minimized) manager.restoreWindow(item.id);
                  else if (active()) manager.minimizeWindow(item.id);
                  else manager.focusWindow(item.id);
                }}
                title={item.title}
              >
                <PixelIcon name={item.icon} size={16} />
                <span>{item.title}</span>
              </button>
            );
          }}
        </For>
      </div>
      <div class="taskbar-tray">
        <span class="tray-indicator" title="Project registry status">◈</span>
        <Clock />
      </div>
    </footer>
  );
}
